angular.module('Toke').factory('deeplinkService', DeeplinkService);

DeeplinkService.$inject = ['$window'];

function DeeplinkService($window) {

    return {
        getCurrentUrl,
        getQueryParams,
        isMobile,
        validateParams,
        getValidationErrors,
        buildDeeplink,
        redirectToChannel
    };

    /**
     * Obtiene la URL actual del navegador
     * @returns {string} URL completa de la página actual
     */
    function getCurrentUrl() {
        return $window.location.href;
    }

    /**
     * Extrae los parámetros de consulta de la URL actual y los devuelve como un objeto
     * @returns {Object} Pareja clave-valor de los parámetros de consulta
     */
    function getQueryParams() {
        const params = new URLSearchParams($window.location.search);
        const result = {};

        params.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }

    /**
     * Detecta si el usuario está en un dispositivo móvil
     * @returns {boolean} True si el dispositivo es móvil
     */
    function isMobile() {
        const ua = $window.navigator.userAgent;
        if (/Android|iPhone|iPod/i.test(ua)) return true;
        if (/iPad/i.test(ua)) return true;
        // iPadOS 13+
        if (/Macintosh/i.test(ua) && $window.navigator.maxTouchPoints > 1) return true;
        return false;
    }


    /**
     * Valida los parámetros de consulta contra las reglas definidas en la configuración
     * @param {Object} params - Parámetros de consulta
     * @param {Object} config - Configuración con reglas de validación
     * @returns {boolean} True si los parámetros son válidos
     */
    function validateParams(params, config) {
        return getValidationErrors(params, config).length === 0;
    }

    /**
     * Genera un array de mensajes de error basados en la validación de los parámetros de consulta contra la configuración
     * @param {Object} params - Parámetros de consulta
     * @param {Object} config - Configuración con reglas de validación
     * @returns {Array} Array de mensajes de error, vacío si no hay errores
     */
    function getValidationErrors(params, config) {
        const errors = [];

        config.requiredParams.forEach(param => {
            if (!params[param]) {
                errors.push(`${param} is required`);
            }
        });

        if (params._dl && !config.supportedDlTypes.includes(params._dl)) {
            errors.push('Invalid _dl value');
        }

        return errors;
    }

    /**
     * Construye la URL de deeplink para un canal específico basado en los parámetros de consulta y la configuración de mapeo
     * @param {string} channelId - Identificador del canal
     * @param {Object} params - Parámetros de consulta fuente
     * @param {Object} config - Configuración con mapeos de canales y tipos de deeplink
     * @returns {string|null} URL de deeplink construida o null si el canal no es válido
     */
    function buildDeeplink(channelId, params, config) {
        const channel = config.channels[channelId];

        if (!channel) {
            return null;
        }

        const mappedDl = channel.mappings[params._dl];

        return (
            `${channel.baseUrl}/${channel.path}` +
            `?_dl=${encodeURIComponent(mappedDl)}` +
            `&_smtype=${config.smtype}` +
            `&_p=${encodeURIComponent(params._p)}`
        );
    }

    /**
     * Redirige al usuario a la URL de deeplink construida para el canal seleccionado
     * @param {string} channelId - Identificador del canal
     * @param {Object} params - Parámetros de consulta fuente
     * @param {Object} config - Configuración con mapeos de canales y tipos de deeplink
     */
    function redirectToChannel(channelId, params, config) {
        const deeplink = buildDeeplink(channelId, params, config);

        if (deeplink) {
            $window.location.href = deeplink;
        }
    }
}
